import { Box } from "@mui/material";
import React from "react";
import axiosInstance from "../../../utils/axios";


export default function DownloadLink(props){

    const {
        path='',
        title=''
    } = props;

    const downloadFile = () => {
        const apiPath = `${process.env.REACT_APP_API_URL}/${path}`;

        axiosInstance.get(apiPath,{
            timeout: 300000,
            withCredentials:true,
            responseType: "arraybuffer"
        }).then(response => {
            const blob = new Blob([response.data]);
            const link = document.createElement('a')
            const filename = title; 
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            link.click()

        }).catch(err => {
            console.log('caught the error');
            console.log(err);
        });
    }

    return (
        <Box onClick={downloadFile} sx={{cursor:'pointer'}}>
            {title}
        </Box>
    );

}